import { bisector, format, type Numeric } from "d3";
import type { DataPoint } from "../interfaces";

type SearchType = "left" | "center" | "right";

export const useCartesianSerieUtils = () => {
	const findPointWithX = bisector<DataPoint, Numeric>((d) => d.x);

	const isValidFoundPoint = (data: DataPoint[], index: number, x: Numeric) => {
		if (index === data.length - 1 || data[index + 1].y == null) {
			// Point may be outside curve
			return x.valueOf() <= data[index].x.valueOf();
		}
		if (index === 0 || data[index - 1].y === null) {
			return x.valueOf() >= data[index].x.valueOf();
		}

		return true;
	};

	const searchPoint = <T extends DataPoint = DataPoint>(
		data: T[],
		x: Numeric,
		type: SearchType,
		limit?: number
	) => {
		let index = findPointWithX[type](data, x);

		let point = data[index];
		if (!point) return null;

		while (point.y == null && index !== 0) {
			index -= 1;
			point = data[index];
		}

		if (limit && Math.abs(point.x.valueOf() - x.valueOf()) > limit) return null;

		if (!limit && !isValidFoundPoint(data, index, x)) return null;

		return { index, point };
	};

	return { searchPoint, format };
};
